import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import { reviews, categories } from '@/mocks/data';
import { Link } from 'react-router-dom';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpValue = (formData.get('company_alt') as string || '').trim();
    if (hpValue) {
      setFormStatus('success');
      return;
    }

    formData.delete('company_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9st0fllbrt1qcgaj9mg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后再试';
        setFormError(msg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <ScrollToTop />
      <SEOSchema
        type="WebPage"
        data={{
          name: '关于我们 - 乳色吐息动漫',
          description: '了解乳色吐息动漫粉丝站的品牌故事、口碑评价与联系方式。最全面的乳色吐息动漫内容平台。',
        }}
      />

      <Navbar />
      <main className="pt-16">
        <section className="relative w-full h-[300px] md:h-[380px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cozy%20community%20space%20with%20soft%20cream%20and%20rose%20lighting%2C%20anime%20art%20books%20and%20collectibles%20displayed%20on%20wooden%20shelves%2C%20inviting%20reading%20nook%20with%20warm%20ambient%20light%2C%20creative%20studio%20atmosphere%2C%20gentle%20and%20welcoming%20vibe&width=1600&height=800&seq=about-hero-01&orientation=landscape"
            alt="关于我们 乳色吐息动漫"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/45"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">关于我们</h1>
            <p className="text-sm md:text-base text-white/70 max-w-lg mx-auto">
              了解乳色吐息动漫粉丝站的故事与使命
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { name: '首页', path: '/' },
                  { name: '关于我们' },
                ]}
              />
            </div>
          </div>
        </section>

        <section className="pb-14 md:pb-20 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                品牌故事
              </h2>
              <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
                <p>
                  乳色吐息动漫粉丝站创立于2024年，由一群热爱这部作品的资深动漫爱好者共同发起。我们的初心很简单——为所有喜欢乳色吐息的朋友打造一个温暖、专业、值得信赖的内容平台。
                </p>
                <p>
                  在这个平台上，你可以找到最全面的剧情解析、最深入的角色分析、最实用的观看指南以及最真诚的作品评测。我们坚持原创内容，每一篇文章都由团队成员精心撰写，力求为读者提供最有价值的阅读体验。
                </p>
                <p>
                  "乳色吐息"这个名字本身就蕴含着一种温柔而深刻的美学。我们希望这个粉丝站也能像作品本身一样，成为粉丝们在这个喧嚣世界中的一处宁静港湾——在这里，你可以放慢脚步，细细品味那些触动心弦的故事与情感。
                </p>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                我们的理念
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="bg-background-100 rounded-xl p-6 text-center">
                  <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-heart-line text-xl"></i>
                  </span>
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">热爱驱动</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    每一篇文章都源于对作品的真挚热爱，而非商业利益的驱使。
                  </p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 text-center">
                  <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-shield-check-line text-xl"></i>
                  </span>
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">内容至上</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    坚持原创、深度、优质的内容标准，对每一位读者负责。
                  </p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 text-center">
                  <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-group-line text-xl"></i>
                  </span>
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">社区共建</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    与粉丝共同成长，聆听每一位社区成员的声音与建议。
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">
                用户口碑
              </h2>
              <div className="flex flex-col gap-4">
                {reviews.map((review, index) => (
                  <div key={index} className="bg-background-100 rounded-xl p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      {review.content}
                    </p>
                    <div className="flex items-center gap-3">
                      <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-primary-600 font-heading font-bold text-sm">
                          {review.name.charAt(0)}
                        </span>
                      </span>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                        <p className="text-xs text-foreground-400">{review.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 mb-8">
                有任何建议、合作意向或想要加入我们的团队？请通过以下表单与我们取得联系，我们会在24小时内回复。
              </p>

              <form
                onSubmit={handleSubmit}
                action="https://readdy.ai/api/form/d9st0fllbrt1qcgaj9mg"
                method="POST"
                className="bg-background-100 rounded-xl p-6 md:p-8"
                data-readdy-form="true"
              >
                <div className="form-hp-wrap">
                  <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm text-foreground-700 mb-1.5" htmlFor="contact-name">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-foreground-700 mb-1.5" htmlFor="contact-email">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-sm text-foreground-700 mb-1.5" htmlFor="contact-subject">
                    主题 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入主题"
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-sm text-foreground-700 mb-1.5" htmlFor="contact-message">
                    留言 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                </div>

                {formStatus === 'error' && (
                  <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-600 text-sm">
                    {formError}
                  </div>
                )}
                {formStatus === 'success' && (
                  <div className="mb-4 p-3 rounded-lg bg-green-50 text-green-600 text-sm">
                    感谢您的留言！我们会在24小时内回复您。
                  </div>
                )}

                <button
                  type="submit"
                  className="px-8 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  发送留言
                </button>
              </form>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              探索我们的内容
            </h2>
            <p className="text-sm text-foreground-500 mb-6 max-w-md mx-auto">
              从不同角度了解乳色吐息动漫的魅力
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-5 py-2.5 rounded-full bg-background-50 text-sm text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer newsletterSubmitAddr="https://readdy.ai/api/form/d9st0fllbrt1qcgaj9n0" />
    </>
  );
}